import React, { memo } from 'react';
import { Button } from 'react-bootstrap';

const OrderHeader = ({
  canEdit,
  customerName,
  onAddProductClick,
  onBackClick,
  onDownload,
  orderId,
  showRecalculateButton = false,
  recalculating = false,
  onRecalculateClick,
}) => (
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h1 className='title'>
      Detalle de la orden{' '}
      {!!orderId && (
        <>
          {orderId}
          <br />
          <span style={{ fontSize: '0.6em' }}>{customerName}</span>
        </>
      )}
    </h1>
    <div>
      {showRecalculateButton && (
        <Button
          variant="primary"
          onClick={onRecalculateClick}
          disabled={recalculating}
          style={{ marginRight: '12px' }}
        >
          {recalculating ? 'Recalculando…' : 'Recalcular precio final'}
        </Button>
      )}
      {!!canEdit && (
        <Button
          variant="primary"
          onClick={onAddProductClick}
          style={{ marginRight: '12px' }}
        >
          Añadir producto
        </Button>
      )}
      <Button
        variant="warning"
        onClick={onDownload}
        style={{ marginRight: '12px' }}
      >
        Descargar
      </Button>
      <Button variant="secondary" onClick={onBackClick}>
        Regresar
      </Button>
    </div>
  </div>
);

export default memo(OrderHeader);
